module.exports = __webpack_public_path__ + "img/b1.53b1d37b.jpg";